import React from 'react';
import { strings } from '../../../../localization';
import { ModalContainer } from '../../../common/Modal2';
import webappStreamToDownloadRequestSuccessWireframeSrc from '../LiveStream/images/webapp_stream_to_download_request_success-wireframe.png';
import webappStreamToDownloadRequestSuccessWireframeSrcTelus from '../LiveStream/images/webapp_stream_to_download_request_success-wireframe_telus.png';
import PropTypes from 'prop-types';
import EnhancedVideoAccessDownload from './EnhancedVideoAccessDownload';

import { EVA_TIMELINE_DRAGGER_DURATION_PRESETS } from './EnhancedVideoAccess';

const wireframeVariants = {
    telus: webappStreamToDownloadRequestSuccessWireframeSrcTelus,
};
const wireframeSrc = wireframeVariants[process.env.REACT_APP_FEATURE_SET] || webappStreamToDownloadRequestSuccessWireframeSrc;

export default class EnhancedVideoAccessControlPanel extends React.PureComponent {

    static propTypes = {
        toggleEnhancedVideoAccessModeActive: PropTypes.func.isRequired,
        ravenId: PropTypes.string.isRequired,
        stage: PropTypes.string.isRequired,
        availableDatesSelectLookup: PropTypes.object.isRequired,
        cardStartDate: PropTypes.instanceOf(Date).isRequired,
        cardEndDate: PropTypes.instanceOf(Date).isRequired,
        controlPanelRequestedSelectedDate: PropTypes.instanceOf(Date).isRequired,
        setDraggerStartTime: PropTypes.func.isRequired,
        draggerDurationSeconds: PropTypes.number.isRequired,
        setDraggerDurationSeconds: PropTypes.func.isRequired,
        onRequestDownloadModalToggle: PropTypes.func.isRequired
    }

    state = {
        modalContainer: null
    }

    datesAreOnSameDay = (first, second) => {
        if (first.getFullYear() === second.getFullYear() &&
            first.getMonth() === second.getMonth() &&
            first.getDate() === second.getDate()) {
            return true;
        }
        return false;
    }

    datesAreOnSameDaySameHour = (first, second) => {
        if (first.getFullYear() === second.getFullYear() &&
            first.getMonth() === second.getMonth() &&
            first.getDate() === second.getDate() &&
            first.getHours() === second.getHours()) {
            return true;
        }
        return false;
    }

    getAvailableHoursSelectValuesForDay = () => { // "SelectValues" are strings with preceding 0's where necessary
        let firstHour = 0;
        let lastHour = 23;
        if (this.datesAreOnSameDay(this.props.controlPanelRequestedSelectedDate, this.props.cardStartDate)) {
            firstHour = this.props.cardStartDate.getHours();
            if (firstHour > 0 && this.props.cardStartDate.getMinutes() > 45) {
                firstHour -= 1;
            } // <-- still could be a slight bug for a very short trip?
        }
        if (this.datesAreOnSameDay(this.props.controlPanelRequestedSelectedDate, this.props.cardEndDate)) {
            lastHour = this.props.cardEndDate.getHours();
        }
        let values = [];
        for (let i = firstHour; i <= lastHour; i += 1) {
            let value = String(i);
            if (value.length < 2) {
                value = "0" + value;
            }
            values.push(value);
        }
        return values;
    }

    getAvailableMinuteBlocksSelectValuesForDay = () => {
        const timeBlocks = [0, 15, 30, 45];
        if (this.datesAreOnSameDaySameHour(this.props.controlPanelRequestedSelectedDate, this.props.cardStartDate)) {
            const firstMinute = this.props.cardStartDate.getMinutes();
            for (let i = 0; i < timeBlocks.length; i += 1) {
                if (timeBlocks[i] < firstMinute) {
                    timeBlocks.shift();
                }
            }
        }
        if (this.datesAreOnSameDaySameHour(this.props.controlPanelRequestedSelectedDate, this.props.cardEndDate)) {
            const lastMinute = this.props.cardEndDate.getMinutes();
            for (let i = timeBlocks.length - 1; i >= 0; i -= 1) {
                if (timeBlocks[i] > lastMinute) {
                    timeBlocks.pop();
                }
            }
        }
        return timeBlocks.map((timeBlock) => {
            const value = String(timeBlock);
            if (value < 2) {
                return "0" + value;
            }
            return value;
        });
    }

    validateAndSetRequestedDate = (requestedDate) => {
        let validDate = new Date(requestedDate.getTime());
        if (requestedDate < this.props.cardStartDate) {
            validDate = new Date(this.props.cardStartDate.getTime());
        }

        const requestedDateMaxSelectTime = new Date(requestedDate.getTime() + (this.props.draggerDurationSeconds * 1000));
        if (requestedDateMaxSelectTime > this.props.cardEndDate) {
            validDate = new Date(this.props.cardEndDate.getTime() - (this.props.draggerDurationSeconds * 1000));
        }
        this.props.setDraggerStartTime(validDate);
    }

    onClickDownload = () => {

        // Modal is open
        this.props.onRequestDownloadModalToggle(true);

        const dismissModalContainer = () => {
            this.setState({modalContainer: null});
            
            //  Modal is closed
            this.props.onRequestDownloadModalToggle(false);
        }

        const onSuccess = () => {
            this.setState({
                modalContainer: (
                    <ModalContainer
                        title={strings.streaming_request_video_download_success_header}
                        smallDialogMode={false}
                        fillToMaxHeightPixels={490}
                        onClickClose={dismissModalContainer}
                    >
                        <div className="message">
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                height: "100%",
                                alignItems: "center"
                            }}>
                                <div style={{
                                    flexShrink: "1",
                                    minHeight: "0"
                                }}>
                                    <img src={wireframeSrc} alt=""/>
                                </div>
                                <div style={{
                                    flexShrink: "0",
                                    padding: "10px 0 0 0"
                                }}>
                                    {strings.streaming_request_video_download_success_description}
                                </div>
                            </div>
                        </div>

                        <div className="actions">
                            <button onClick={dismissModalContainer} >{strings.app_ok}</button>
                        </div>
                    </ModalContainer>
                )
            });    
        }

        const onError = (errorCode, cameraType) => {
            const cameraLabel = cameraType === "ROAD" ? strings.eva_road_camera : strings.eva_cabin_camera;
            this.setState({
                modalContainer: (
                    <ModalContainer
                        title={strings.streaming_request_video_download_error_header}
                        smallDialogMode={true}
                        onClickClose={dismissModalContainer}
                    >
                        <div className="message">
                            {errorCode === 422 ?
                                strings.streaming_request_video_download_error_event_media_source_not_found
                            :
                                cameraLabel + ": " + strings.streaming_request_video_download_error_description
                            }
                        </div>

                        <div className="actions">
                            <button onClick={dismissModalContainer} >{strings.app_ok}</button>
                        </div>
                    </ModalContainer>
                )
            });    
        }

        this.setState({
            modalContainer: (
                <ModalContainer
                    title={strings.streaming_request_video_download_header}
                    smallDialogMode={true}
                    onClickClose={dismissModalContainer}
                >
                    <EnhancedVideoAccessDownload
                        stage={this.props.stage}
                        ravenUuid={this.props.ravenId}
                        timestamp={Math.floor(this.props.controlPanelRequestedSelectedDate.getTime() / 1000)}
                        duration={this.props.draggerDurationSeconds}
                        onCancel={dismissModalContainer}
                        onError={onError}
                        onSuccess={onSuccess}
                    />
                </ModalContainer>
            )
        });
    }

    render() {

        if (!this.props.controlPanelRequestedSelectedDate || !this.props.cardStartDate || !this.props.cardEndDate) {
            // progress spinner here?
            return null;
        }
        
        const [selectedDateIsoString] = this.props.controlPanelRequestedSelectedDate.toISOString().split('T');

        const availableHoursSelectValuesForDay = this.getAvailableHoursSelectValuesForDay(this.props.cardStartDate, this.props.cardEndtDate);
        let selectedHour = String(this.props.controlPanelRequestedSelectedDate.getHours());
        if (selectedHour.length < 2) {
            selectedHour = "0" + selectedHour;
        }
        
        const availableMinuteBlocksSelectValuesForDay = this.getAvailableMinuteBlocksSelectValuesForDay(this.props.cardStartDate, this.props.cardEndtDate);
        let selectedMinute = String(this.props.controlPanelRequestedSelectedDate.getMinutes());
        let selectedMinuteIsCustom = true;
        if (selectedMinute.length < 2) {
            selectedMinute = "0" + selectedMinute;
        }
        if (availableMinuteBlocksSelectValuesForDay.includes(selectedMinute)) {
            selectedMinuteIsCustom = false;
        }

        return (
            <div className="eva-control-panel-container">
                {/*
                <ul className="eva-timeline-scale-presets">
                    <li><button>{strings.eva_timeline_scale_preset_hr}</button></li>
                    <li className="active"><button>{strings.eva_timeline_scale_preset_min}</button></li>
                    <li><button>{strings.eva_timeline_scale_preset_sec}</button></li>
                </ul>*/}
                <div className="eva-request-download-form">
                    <div className="eva-request-start-and-duration-container">
                        {/*<div className="eva-request-start-time">
                            <div>{strings.eva_request_start_time_label}:</div>
                            <select name="eva-request-date-select" value={selectedDateIsoString} onChange={(event) => {

                                const requestedStartTime = this.props.availableDatesSelectLookup[event.target.value];

                                if (!requestedStartTime) {
                                    console.error("EnhancedVideoAccessControlPanel eve-request-date-select target value key not found in availableDatesSelectLookup");
                                }

                                this.props.setDraggerStartTime(requestedStartTime);
                            }}>
                                {Object.keys(this.props.availableDatesSelectLookup).map((justIOSDate, index) => {
                                    return (<option value={justIOSDate} key={index}>{justIOSDate}</option>);
                                })}
                            </select>
                            <div className="eva-request-time-select-container">
                                <i className="material-icons">query_builder</i>
                                <select name="eva-request-time-hour-select" value={selectedHour} className="eva-request-time-hour-select" onChange={ (event) => {
                                    const newHoursValue = parseInt(event.target.value);
                                    let requestedDate = new Date(this.props.controlPanelRequestedSelectedDate.getTime());
                                    requestedDate.setHours(newHoursValue);
                                    this.validateAndSetRequestedDate(requestedDate);
                                }}>
                                    {availableHoursSelectValuesForDay.map( (value) => {
                                        return (<option value={value} key={value}>{value}</option>)
                                    })}
                                </select>
                                :
                                <select name="eva-request-time-minute-select" value={selectedMinute} className="eva-request-time-minute-select" onChange={ (event) => {
                                    const newMinutesValue = parseInt(event.target.value);
                                    const requestedDate = new Date(this.props.controlPanelRequestedSelectedDate.getTime());
                                    requestedDate.setMinutes(newMinutesValue);
                                    this.validateAndSetRequestedDate(requestedDate);
                                }}>
                                    {selectedMinuteIsCustom &&<option value={selectedMinute} key={selectedMinute} disabled selected>{selectedMinute}</option>}
                                    {availableMinuteBlocksSelectValuesForDay.map( (value) => {
                                        return (<option value={value} key={value}>{value}</option>);
                                    })};
                                </select>
                            </div>
                        </div>*/}
                        <div className="eva-request-duration">
                            <div>{strings.eva_request_duration_label}:</div>
                            <div>
                                <select name="eva-request-duration-select" value={this.props.draggerDurationSeconds} onChange={(event) => {
                                    this.props.setDraggerDurationSeconds(parseInt(event.target.value));
                                }}>
                                    <option value={EVA_TIMELINE_DRAGGER_DURATION_PRESETS.SECONDS_15}>{EVA_TIMELINE_DRAGGER_DURATION_PRESETS.SECONDS_15}</option>
                                    <option value={EVA_TIMELINE_DRAGGER_DURATION_PRESETS.SECONDS_30}>{EVA_TIMELINE_DRAGGER_DURATION_PRESETS.SECONDS_30}</option>
                                    <option value={EVA_TIMELINE_DRAGGER_DURATION_PRESETS.SECONDS_45}>{EVA_TIMELINE_DRAGGER_DURATION_PRESETS.SECONDS_45}</option>
                                    <option value={EVA_TIMELINE_DRAGGER_DURATION_PRESETS.SECONDS_60}>{EVA_TIMELINE_DRAGGER_DURATION_PRESETS.SECONDS_60}</option>
                                </select>
                            </div>
                            <div>{strings.eva_request_duration_units}</div>
                        </div>
                    </div>
                    <div className="eva-download-actions">
                        <button className="btn" onClick={this.onClickDownload}>{strings.action_request_download}</button>
                        <button className="btn btn-outline-blue" onClick={this.props.toggleEnhancedVideoAccessModeActive}>{strings.action_cancel}</button>
                    </div>
                </div>
                {this.state.modalContainer}
            </div>

        );
    }
}